import React, { useEffect, useState, useRef } from 'react';
import blogImage1 from '../assets/blogImage1.jpg';
import blogImage2 from '../assets/blogImage2.jpg';
import blogImage3 from '../assets/blogImage3.jpg';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const blogPosts = [
  {
    image: blogImage1,
    title: 'Features of Warals School Management System',
    description:
      'A school management software helps in smooth functioning of a school and making various processes of schools convenient. It ease the task...',
    linking: 'https://blogs.warals.com/features-of-warals-school-management-system/',
  },
  {
    image: blogImage2,
    title: 'Institute Management Software: Effective Way to Manage Your Institutions',
    description:
      'Students, parents, teacher, and administrative decision-makers are the key participants when it comes to coaching institutes...',
    linking: 'https://blogs.warals.com/institute-management-software-effective-way-to-manage-your-institutions/',
  },
  {
    image: blogImage3,
    title: 'Why is Learning Management System(LMS) Important Nowadays?',
    description:
      'Before the Covid-19 Pandemic, internet learning was viewed as a discretionary learning channel, an extravagance to be exact. As the lethal...',
    linking: 'https://blogs.warals.com/why-is-learning-management-systemlms-important-nowadays/',
  },
  {
    image: blogImage1,
    title: 'Features of Warals School Management System',
    description:
      'A school management software helps in smooth functioning of a school and making various processes of schools convenient. It ease the task...',
    linking: 'https://blogs.warals.com/features-of-warals-school-management-system/',
  },
  {
    image: blogImage2,
    title: 'Institute Management Software: Effective Way to Manage Your Institutions',
    description:
      'Students, parents, teacher, and administrative decision-makers are the key participants when it comes to coaching institutes...',
    linking: 'https://blogs.warals.com/institute-management-software-effective-way-to-manage-your-institutions/',
  },
  {
    image: blogImage3,
    title: 'Why is Learning Management System(LMS) Important Nowadays?',
    description:
      'Before the Covid-19 Pandemic, internet learning was viewed as a discretionary learning channel, an extravagance to be exact. As the lethal...',
    linking: 'https://blogs.warals.com/why-is-learning-management-systemlms-important-nowadays/',
  },
];

const chunkArray = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const LatestBlog = () => {
  const [cardsPerSlide, setCardsPerSlide] = useState(window.innerWidth < 768 ? 1 : 3);
  const carouselRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setCardsPerSlide(window.innerWidth < 768 ? 1 : 3);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const blogSlides = chunkArray(blogPosts, cardsPerSlide);

  const handlePrev = () => {
    carouselRef.current.prev();
  };

  const handleNext = () => {
    carouselRef.current.next();
  };

  return (
    <div className="py-5 px-3" style={{ backgroundColor: '#f7fafd', overflowX: 'hidden' }}>
      <div className="text-center mb-4">
        <h2 className="fw-bold">Latest Blog Post</h2>
        <div
          style={{
            width: '60px',
            height: '3px',
            backgroundColor: '#00aaff',
            margin: '10px auto',
          }}
        ></div>
        <p>
          Want to know about the latest technology trends in learning management systems? You can find all of them here.
        </p>
      </div>

      <div className="container position-relative px-lg-5">
        <Carousel indicators={false} controls={false} interval={4000} ref={carouselRef}>
          {blogSlides.map((group, i) => (
            <Carousel.Item key={i}>
              <div className="row justify-content-center">
                {group.map((post, index) => (
                  <div className="col-md-4 mb-4" key={index}>
                    <div
                      className="card h-100 shadow-sm border-0"
                      style={{
                        minHeight: '410px',
                        transition: 'transform 0.3s ease',
                        cursor: 'pointer',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      <img
                        src={post.image}
                        className="card-img-top"
                        alt={`Blog ${index}`}
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                      <div className="card-body">
                        <h5 className="card-title text-start">{post.title}</h5>
                        <p className="card-text text-muted text-start" style={{ fontSize: '0.95rem' }}>
                          {post.description}{' '}
                          <a href={post.linking} style={{ color: 'blue', textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                            Read More
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Custom Carousel Navigation Buttons */}
        <button
          onClick={handlePrev}
          className="position-absolute top-50 start-0 translate-middle-y d-none d-md-flex align-items-center justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: 'white',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            zIndex: 1,
            left: '-20px',
          }}
          aria-label="Previous blogs"
        >
          <i className="bi bi-chevron-left text-primary" style={{ fontSize: '1.25rem' }} />
        </button>

        <button
          onClick={handleNext}
          className="position-absolute top-50 end-0 translate-middle-y d-none d-md-flex align-items-center justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            border: 'none',
            backgroundColor: 'white',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            zIndex: 1,
            right: '-20px',
          }}
          aria-label="Next blogs"
        >
          <i className="bi bi-chevron-right text-primary" style={{ fontSize: '1.25rem' }} />
        </button>
      </div>
    </div>
  );
};

export default LatestBlog;
